import type { ThemeOptions } from "@mui/material";

// Defined font weights to be used throughout the theme (MUI uses 300, 400, 500, 700 by default)
const FONT_WEIGHTS = {
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600, // Custom integration
  bold: 700,
};

const FONT_FAMILY_FALLBACKS = [
  '"Open Sans"',
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  '"Helvetica Neue"',
  "Arial",
  "sans-serif",
];

const GLOBAL_FONT_FAMILY = ['"Open Sans"', ...FONT_FAMILY_FALLBACKS].join(",");

const HEADING_FONT_FAMILY = ['"Titillium Web"', ...FONT_FAMILY_FALLBACKS].join(
  ",",
);

export const CUSTOM_TYPOGRAPHY: ThemeOptions["typography"] = {
  fontFamily: GLOBAL_FONT_FAMILY,
  fontWeightLight: FONT_WEIGHTS.light,
  fontWeightRegular: FONT_WEIGHTS.regular,
  fontWeightMedium: FONT_WEIGHTS.medium,
  fontWeightSemiBold: FONT_WEIGHTS.semiBold, // Custom integration
  fontWeightBold: FONT_WEIGHTS.bold,
  h1: {
    fontFamily: HEADING_FONT_FAMILY,
    fontWeight: FONT_WEIGHTS.bold,
    fontSize: "1.75rem",
    lineHeight: 1.2,
    letterSpacing: "-0.01em",
  },
  h2: {
    fontFamily: HEADING_FONT_FAMILY,
    fontWeight: FONT_WEIGHTS.bold,
    fontSize: "1.5rem",
    lineHeight: 1.2,
    letterSpacing: "-0.01em",
  },
  h3: {
    fontFamily: HEADING_FONT_FAMILY,
    fontWeight: FONT_WEIGHTS.semiBold,
    fontSize: "1.5rem",
    lineHeight: 1.2,
    letterSpacing: "-0.01em",
  },
  h4: {
    fontFamily: HEADING_FONT_FAMILY,
    fontWeight: FONT_WEIGHTS.bold,
    fontSize: "1.25rem",
    lineHeight: 1.2,
    letterSpacing: "-0.01em",
  },
  h5: {
    fontFamily: HEADING_FONT_FAMILY,
    fontWeight: FONT_WEIGHTS.semiBold,
    fontSize: "1.25rem",
    lineHeight: 1.2,
    letterSpacing: "-0.01em",
  },
  h6: {
    fontFamily: HEADING_FONT_FAMILY,
    fontWeight: FONT_WEIGHTS.bold,
    fontSize: "2.25rem",
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
  },
  subtitle1: {
    fontWeight: FONT_WEIGHTS.semiBold,
    fontSize: "1.5rem",
    lineHeight: 1.3,
    letterSpacing: "-0.02em",
  },
  subtitle2: {
    fontWeight: FONT_WEIGHTS.semiBold,
    fontSize: "1.25rem",
    lineHeight: 1.3,
    letterSpacing: "-0.02em",
  },
  body1: {
    fontWeight: FONT_WEIGHTS.regular,
    fontSize: "1rem",
    lineHeight: 1.4,
    letterSpacing: "-0.02em",
  },
  body2: {
    fontWeight: FONT_WEIGHTS.regular,
    fontSize: "0.875rem",
    lineHeight: 1.4,
    letterSpacing: "-0.02em",
  },
  caption: {
    fontWeight: FONT_WEIGHTS.medium,
    fontSize: "0.75rem",
    lineHeight: 1.4,
    letterSpacing: "-0.01em",
  },
  overline: {
    fontWeight: FONT_WEIGHTS.medium,
    fontSize: "0.625rem",
    lineHeight: 1.4,
    letterSpacing: "-0.01em",
  },
};
